import {SchemasOrderDetail} from '@shared/schemas/order'

import {BankCodeType} from '@web/core/constants'
import getApi, {createWrapper} from '@web/helpers/api'
import {isBankCode} from '@web/helpers/policies'

export const ApiBaseUrl = `/orderApi/orderSheet/detail`

export const ApiUrlInfo = {
    /** 무통장입금 은행 변경 */
    bank: '/virtualAccount/bank',
}

const api = getApi(ApiBaseUrl)

type ChangeVirtualAccountBankParams = {
    /** 주문번호 */
    orderNo: string
    /** 변경할 은행코드.
     * @example BNK002 */
    bankCode: string
}

/** 은행코드에 BNK prefix를 붙이거나 제거 */
export function parseBankCode(bankCode: string, type: 'add'): Maybe<string>
export function parseBankCode(bankCode: string, type: 'remove'): Maybe<BankCodeType>
export function parseBankCode(bankCode: string, type: 'add' | 'remove') {
    if (!bankCode) {
        return null
    }

    const prefix = 'BNK'

    if (type === 'remove') {
        const removed = bankCode.replace(prefix, '')
        return isBankCode(removed) ? removed : null
    }

    const added = `${prefix}${bankCode}`
    return isBankCode(bankCode) ? added : null
}

/** 무통장입금 은행 변경 */
async function changeBank({orderNo, bankCode}: ChangeVirtualAccountBankParams) {
    const result = await createWrapper<SchemasOrderDetail['/virtualAccount/bank']['response']>(
        api.post(ApiUrlInfo.bank, {
            orderNo,
            bankCode: parseBankCode(bankCode, 'add'),
        }),
    )

    return {...result, bankCode: parseBankCode(result.bankCode, 'remove')}
}

export {changeBank}
